import get from "lodash/get";
import {
  LAMBDATEST_BUILD_DATA_LOADING,
  LAMBDATEST_BUILD_DATA_SUCCESS,
  LAMBDATEST_BUILD_DATA_FAILED,
  LAMBDATEST_BUILD_DATA_CLEAR,
  LAMBDATEST_SET_BUILDID_WHILE_FETCHING,
  LAMBDATEST_BUILD_DATA_FETCH_MORE_LOADING,
  LAMBDATEST_BUILD_DATA_FETCH_MORE_SUCCESS,
  LAMBDATEST_BUILD_DATA_FETCH_MORE_FAILED,
  LAMBDATEST_BUILD_DATA_SILENT_LOADING,
  LAMBDATEST_BUILD_TESTLIST_SILENT_LOADING,
  LAMBDATEST_UPDATE_BUILDNAME_LOADING,
  LAMBDATEST_UPDATE_BUILDNAME_SUCCESS,
  LAMBDATEST_UPDATE_BUILDNAME_FAILED,
  LAMBDATEST_UPDATE_BUILDNAME_CLEAR,
  LAMBDATEST_UPDATE_BUILD_DATA_SUCCESS,
  LAMBDATEST_UPDATE_BUILD_FIELD,
  SHOW_SAMPLE_BUILD,
  LAMBDATEST_LOAD_SAMPLE_BUILD_DATA_SUCCESS,
  LAMBDATEST_LOAD_SAMPLE_BUILD_DATA_FAILED,
  LAMBDATEST_UPDATE_ACTIVE_BUILD_TAB,
  LAMBDATEST_FILTER_BUILD_DATA_SUCCESS,
  LAMBDATEST_FILTER_BUILD_DATA_LOADING,
  LAMBDATEST_FILTER_BUILD_DATA_FAILED,
  SET_IS_BUILD_SELECTED_VIA_KEYBOARD,
  LAMBDATEST_DELETE_BUILD_LOCAL,
  LAMBDATEST_UPDATE_BUILD_LIST
} from "../actionTypeConstants/LambdaTestBuildDataConstants";

import { currentOffsetValue } from "../actions/lambdaTestBuildDataActions";

import {
  BuildTestTabs,
  DEFAULT_BUILD_DATA_API_CALL_LIMIT
} from "../../common/constants/View";
import { deleteObjectById, parseJwt } from "../../utility/utilityFunctions";
import { getCookieData } from "../../utility/cookieHandler/handler";

const initialState = {
  buildData: {
    loading: false,
    data: null,
    error: null,
    loadingMore: false,
    loadingMoreError: null,
    total: 0,
    silentLoading: false
  },
  isCallFromInfiniteScroller: false,
  isSampleBuild: false,
  isBuildSelectedViaKeyboard: false,
  activeBuildTab: BuildTestTabs.BUILD_SESSIONS
};

let currentFetchingBuildID = null;
let buildDataToUpdate, buildDataArray;

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LAMBDATEST_BUILD_DATA_LOADING: {
      const offsetValue = parseInt(
        get(action, ["payload", "currentOffsetValue"], currentOffsetValue)
      );
      const resetBuildData = get(action, ["payload", "resetBuildData"], false);
      return {
        ...state,
        buildData: {
          ...state.buildData,
          loading: true,
          data: resetBuildData ? null : state.buildData?.data

          // silentLoading: false
        },
        isCallFromInfiniteScroller: offsetValue !== 0
      };
    }
    case LAMBDATEST_BUILD_DATA_SILENT_LOADING:
      return {
        ...state,
        buildData: {
          ...state.buildData,
          // loading: false,
          silentLoading: true
        }
      };

    case LAMBDATEST_BUILD_DATA_SUCCESS:
      // debugger
      const offsetValue = parseInt(
        get(action, ["payload", "currentOffsetValue"], currentOffsetValue)
      );

      const limit = get(
        action,
        ["payload", "limit"],
        DEFAULT_BUILD_DATA_API_CALL_LIMIT
      );

      buildDataToUpdate = action.result.data.builds.map(item => {
        return {
          ...item,
          testListData: {
            loading: false,
            data: null,
            error: null,
            loadingMore: false,
            loadingMoreError: null,
            silentLoading: false
          }
        };
      });
      let hasMore = true;
      if (action.result.data.builds.length < limit) {
        hasMore = false;
      }

      // Simple append logic (similar to tests reducer) - avoids null value issues
      if (offsetValue === 0) {
        // Initial load - replace data
        buildDataArray = buildDataToUpdate;
      } else {
        // Pagination - append to existing data
        buildDataArray = [...(state.buildData.data || []), ...buildDataToUpdate];
      }
      const sampleFrameworkName = get(
        action,
        ["result", "data", "framework"],
        ""
      );

      // This is a demo build. Update the "createTimestamp" based on localStorage if available.
      if (sampleFrameworkName) {
        const cookieName = process.env.REACT_APP_COOKIE_NAME;
        const accessToken = getCookieData(cookieName);
        const parsedToken = parseJwt(accessToken);
        const orgId = parsedToken["organization_id"] || 0;
        const isDemoBuildClickedTimestamp = localStorage.getItem(
          `isDemoUser-${orgId}`
        );
        if (isDemoBuildClickedTimestamp) {
          const updatedTimestamp = isDemoBuildClickedTimestamp;
          buildDataArray.forEach(item => {
            item.createdAt = updatedTimestamp;
          });
        }
      }

      return {
        ...state,
        buildData: {
          ...state.buildData,
          loading: false,
          // silentLoading: true,
          total: action.result.data.total,
          data: buildDataArray,
          hasMore: hasMore
        },
        isCallFromInfiniteScroller: offsetValue !== 0,
        isSampleBuild: !!sampleFrameworkName
      };

    case SHOW_SAMPLE_BUILD: {
      const { payload = {} } = action;
      const { data = {} } = payload;
      return {
        ...state,
        buildData: {
          ...state.buildData,
          loading: false,
          total: 1,
          data: data
        },
        isSampleBuild: true
      };
    }

    case LAMBDATEST_LOAD_SAMPLE_BUILD_DATA_SUCCESS: {
      const buildDataArray = get(action.result, ["data", "builds"]);
      return {
        ...state,
        buildData: {
          ...state.buildData,
          data: buildDataArray
        },
        isSampleBuild: true
      };
    }

    case LAMBDATEST_LOAD_SAMPLE_BUILD_DATA_FAILED: {
      return {
        ...state
      };
    }

    case LAMBDATEST_UPDATE_BUILD_DATA_SUCCESS:
      buildDataArray = state.buildData.data || [];
      const updatedBuild = get(action.result, ["data", "builds", 0], null);

      // Handle the removal of dummy builds if the incoming build is the first legit build and the rest 2 were dummy builds
      if (
        get(state, ["buildData", "data"], []).length === 2 &&
        state.isSampleBuild
      ) {
        state.buildData.data.splice(0, 2);
      }

      if (updatedBuild) {
        const index = buildDataArray.findIndex(
          obj => obj.buildId === updatedBuild.buildId
        );
        if (index !== -1) {
          buildDataArray[index] = updatedBuild;
        } else {
          buildDataArray = [updatedBuild, ...buildDataArray];
        }
      }
      return {
        ...state,
        buildData: {
          ...state.buildData,
          data: buildDataArray
        },
        isSampleBuild: false
      };

    case LAMBDATEST_BUILD_DATA_FAILED:
      return {
        ...state,

        buildData: {
          ...state.buildData,
          loading: false,
          error: action.error
          // silentLoading: false
        },
        isSampleBuild: false
      };

    case LAMBDATEST_BUILD_DATA_CLEAR:
      return {
        ...state,
        buildData: initialState.buildData
      };

    case LAMBDATEST_SET_BUILDID_WHILE_FETCHING:
      currentFetchingBuildID = action.buildID;
      return {
        ...state
      };

    case LAMBDATEST_BUILD_TESTLIST_SILENT_LOADING:
      buildDataArray = state.buildData.data;
      buildDataToUpdate = buildDataArray.findIndex(
        item =>
          item &&
          item.buildId &&
          `${item.buildId}` === `${currentFetchingBuildID}`
      );
      buildDataArray[buildDataToUpdate]["testListData"] = {
        ...buildDataArray[buildDataToUpdate]["testListData"],
        loading: false,
        silentLoading: true
      };
      return {
        ...state,
        buildData: {
          ...state.buildData,
          data: buildDataArray
        }
      };

    case LAMBDATEST_BUILD_DATA_FETCH_MORE_LOADING:
      return {
        ...state,
        buildData: {
          ...state.buildData,
          loadingMore: true
        }
      };

    case LAMBDATEST_BUILD_DATA_FETCH_MORE_SUCCESS:
      const newData = action.result.data.builds.map(item => {
        return {
          ...item,
          testListData: {
            loading: false,
            data: null,
            error: null
          }
        };
      });

      return {
        ...state,
        buildData: {
          ...state.buildData,
          loading: false,
          loadingMore: false,
          data: [...state.buildData.data, ...newData]
        }
      };

    case LAMBDATEST_BUILD_DATA_FETCH_MORE_FAILED:
      return {
        ...state,
        buildData: {
          ...state.buildData,
          loadingMore: false,
          error: action.error
        }
      };

    case LAMBDATEST_UPDATE_BUILDNAME_LOADING:
      return {
        ...state,
        buildData: {
          ...state.buildData,
          updatebuildName: {
            loading: true,
            data: {},
            error: null
          }
        }
      };
    case LAMBDATEST_UPDATE_BUILDNAME_SUCCESS:
      const _buildData = [...state.buildData.data];
      let foundIndex = _buildData.findIndex(
        build => build && build.buildId == action.result.data.data.buildId
      );

      _buildData[foundIndex].name = action.result.data.data.name;
      return {
        ...state,
        buildData: {
          ...state.buildData,
          data: _buildData,
          updatebuildName: {
            loading: false,
            data: action.result.data,
            error: null
          }
        }
      };
    case LAMBDATEST_UPDATE_BUILDNAME_FAILED:
      return {
        ...state,
        buildData: {
          ...state.buildData,
          updatebuildName: {
            loading: false,
            data: {},
            error: action.error
          }
        }
      };
    case LAMBDATEST_UPDATE_BUILDNAME_CLEAR:
      return {
        ...state,
        buildData: {
          ...state.buildData,
          updatebuildName: {
            loading: false,
            data: {},
            error: null
          }
        }
      };

    case LAMBDATEST_UPDATE_BUILD_LIST: {
      const updateBuildList = action.payload?.buildList;
      const isBuildUpdatedEvent = action?.payload?.isBuildUpdatedEvent;
      let isNewBuild = action?.payload?.isNewBuild;

      let buildList = state.buildData?.data || [];

      buildList = buildList.map(build => {
        if (updateBuildList[build.buildId]) {
          const _build = { ...build, ...updateBuildList[build.buildId] };
          //this running case comes when test is created
          if (_build.buildStatus === "running") {
            _build.running = _build.running + 1;
            _build.tests = _build.tests + 1;
          }

          delete updateBuildList[build.buildId];
          return _build;
        }
        return build;
      });

      const newBuilds = isNewBuild
        ? Object.values(updateBuildList)?.map(build => {
            return { ...build, running: 1, tests: 1 };
          })
        : [];

      // incase of build updated event, the build might not be present in the list due to some filter applied
      // and might satisfy the filter post build completion, hence add it in the list
      const updatedNewBuild = isBuildUpdatedEvent
        ? Object.values(updateBuildList)?.map(build => {
            return { ...build };
          })
        : [];

      const newBuildList = [...newBuilds, ...updatedNewBuild, ...buildList];

      return {
        ...state,
        buildData: {
          ...state.buildData,
          data: state.isSampleBuild ? [...newBuilds] : newBuildList
        },
        isSampleBuild: false
      };
    }

    case LAMBDATEST_UPDATE_BUILD_FIELD: {
      const { buildId, fieldToUpdate, data } = action.payload;
      let buildList = state.buildData?.data || [];

      const indexOfBuild = buildList?.findIndex(
        build => build.buildId === buildId
      );
      if (indexOfBuild > -1) {
        const oldData = buildList[indexOfBuild][fieldToUpdate];
        if (oldData === data) {
          return state;
        }
        buildList[indexOfBuild][fieldToUpdate] = data;
      }

      return {
        ...state,
        buildData: {
          ...state.buildData,
          data: buildList
        }
      };
    }

    case LAMBDATEST_UPDATE_ACTIVE_BUILD_TAB: {
      const { tabName } = action.payload;
      return {
        ...state,
        activeBuildTab: tabName
      };
    }

    case LAMBDATEST_FILTER_BUILD_DATA_LOADING: {
      return {
        ...state,
        buildData: {
          ...state.buildData,
          loading: true
        }
      };
    }

    case LAMBDATEST_FILTER_BUILD_DATA_FAILED: {
      return {
        ...state,
        buildData: {
          ...state.buildData,
          loading: false
        }
      };
    }

    case LAMBDATEST_FILTER_BUILD_DATA_SUCCESS: {
      const offsetValue = parseInt(
        get(action, ["payload", "currentOffsetValue"], currentOffsetValue)
      );
      buildDataArray =
        state.buildData.data ||
        new Array(offsetValue * DEFAULT_BUILD_DATA_API_CALL_LIMIT).fill(null);
      const currentSelectedBuildId = get(action, ["payload", "buildId"], "");
      const buildsToUpdate = get(action, ["result", "data", "builds"], []);
      let buildToReplaceIndex = -1;
      buildToReplaceIndex = buildDataArray.findIndex(({ buildId = "" }) => {
        return buildId === currentSelectedBuildId;
      });
      if (buildsToUpdate.length === 0) {
        // Reset the test count.
        buildDataArray[buildToReplaceIndex] = {
          ...buildDataArray[buildToReplaceIndex],
          completed: 0,
          cancelled: 0,
          error: 0,
          failed: 0,
          idleTimeout: 0,
          ignored: 0,
          lambdaError: 0,
          passed: 0,
          queued: 0,
          running: 0,
          skipped: 0,
          stopped: 0,
          tests: 0,
          timeout: 0,
          unknown: 0
        };
      } else {
        // Replace the build.
        buildDataArray.splice(buildToReplaceIndex, 1, ...buildsToUpdate);
      }

      return {
        ...state,
        buildData: {
          ...state.buildData,
          loading: false,
          data: buildDataArray
        }
      };
    }

    case SET_IS_BUILD_SELECTED_VIA_KEYBOARD: {
      const { isSelectedViaKeyboard = false } = action.payload;
      return {
        ...state,
        isBuildSelectedViaKeyboard: isSelectedViaKeyboard
      };
    }

    case LAMBDATEST_DELETE_BUILD_LOCAL:
      return {
        ...state,
        buildData: {
          ...state.buildData,
          data: deleteObjectById(
            state.buildData.data,
            "buildId",
            get(action, ["payload"], "")
          )
        }
      };

    default:
      return state;
  }
}
